module.exports = __webpack_public_path__ + "media/icons/calendar-a1e5c3e3.svg";